import type { i18n } from "i18next"
import { useTranslation } from "react-i18next"

export type Locale = "de" | "de-AT" | "en" | "en-GB" | "en-US"
export type Lang = "de" | "en"

const LOCALES = ["de", "de-AT", "en", "en-GB", "en-US"]
const LANGS = ["de", "en"]

function getLocale(i18n: i18n): Locale {
  if (i18n.language) {
    if (LOCALES.includes(i18n.language)) {
      return i18n.language as any
    }
  }

  if (typeof navigator !== "undefined" && navigator.languages) {
    for (const locale of navigator.languages) {
      if (LOCALES.includes(locale)) {
        return locale as any
      }
    }
  }

  return "de-AT"
}

function getLang(locale: Locale): Lang {
  if (!locale) return "de"

  const [lang] = locale.split("-")
  if (LANGS.includes(lang)) return lang as any

  return "de"
}

interface LocaleHook {
  isDefaultLocale: boolean
  locale: Locale
  lang: Lang
}

const useLocale = (): LocaleHook => {
  const { i18n } = useTranslation<string>()

  const locale = getLocale(i18n)
  const isDefaultLocale = locale === "de-AT"
  const lang = getLang(locale)

  return {
    isDefaultLocale,
    locale,
    lang,
  }
}

export default useLocale
